import { Suspense } from 'react';
import { Outlet } from 'react-router';

import login from '@/assets/images/eliio-product-mockup.png';
import logo from '/eliio-logo.svg';
import { Banner, BannerImage } from '@/components/ui/banner';
import { Loader } from '@/components/ui/loader';

/**
 * Shared frame for every signed-out screen: the mark and the form column on the
 * left, the product artwork on the right. It is a layout route, so moving
 * between login, forgot password and the rest swaps only the form while the
 * artwork stays mounted.
 */
export const AuthLayout = () => {
  return (
    <div className="mx-auto grid min-h-screen grid-cols-2">
      <div className="col-span-2 flex items-center justify-center p-6 md:col-span-1 md:p-[100px]">
        <div className="flex w-full flex-col gap-10 md:max-w-[500px]">
          {/* Centred on the "eliio" wordmark, not on the whole image: the
              orange mark hangs off to the left. In the 1059-wide SVG the
              wordmark (and "bookings") centre at x 684, the image at 529.5,
              so the shift is 154.5 / 1059 of the image's own width. */}
          <img
            src={logo}
            alt="Eliio"
            className="mx-auto w-48 -translate-x-[14.6%]"
          />

          {/* Its own boundary, so a lazy page loading in shows the spinner in
              the form column instead of blanking the whole screen. */}
          <Suspense
            fallback={
              <div className="flex justify-center py-10">
                <Loader />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </div>
      </div>

      <div className="hidden items-center justify-center md:flex">
        {/* No background of its own, so the column stays the same neutral-90 as
            the rest of the page and no seam shows down the middle. The artwork
            sits centred at its own size: `BannerImage` stretches to fill by default,
            which upscaled this 648x465 mockup past its natural size and made it
            soft. The max-* pair only ever shrinks it, on a narrow column. */}
        <Banner
          className="flex items-center justify-center rounded-none md:h-full"
          overlay={false}
        >
          <BannerImage
            src={login}
            alt="The Eliio dashboard on a laptop and a phone"
            className="h-auto max-h-full w-auto max-w-full"
          />
        </Banner>
      </div>
    </div>
  );
};
